import * as amplitude from '@amplitude/analytics-browser';

interface ImpersonationContext {
  id: string;
  // Deferred: no Heimdall user-by-id lookup exists to resolve the employee's email,
  // so events carry impersonator_id only until that lookup lands.
  email?: string;
}

let impersonationContext: ImpersonationContext | null = null;

export const setImpersonationContext = (impersonator: ImpersonationContext | null) => {
  impersonationContext = impersonator;
};

export const getImpersonationContext = () => impersonationContext;

/**
 * Enhanced track function that automatically adds impersonation context
 */
export const track = (eventType: string, properties?: Record<string, unknown>) => {
  const enhancedProperties = {
    ...properties,
    is_impersonating: !!impersonationContext,
    ...(impersonationContext && {
      impersonator_id: impersonationContext.id,
      // Only stamp the email when present so we never emit `impersonator_email: undefined`.
      ...(impersonationContext.email && { impersonator_email: impersonationContext.email }),
    }),
  };

  amplitude.track({
    event_type: eventType,
    event_properties: enhancedProperties,
  });
};
